import { styled } from '@mui/material/styles';

import Button from '@mui/material/Button';

import isColorDark from '../../../../utils/isColorDark';

export const RootStyled = styled('div')(({ theme }) => ({
  padding: theme.spacing(8),
  minHeight: '100%',
  marginTop: -60,
}));

export const TitleContainer = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: 20,
});

export const TicketsBtn = styled(Button)(({ theme }) => ({
  color: isColorDark(theme.palette.primary.main)
    ? theme.palette.global.white
    : theme.palette.global.black,
  textTransform: 'none',
  '&:hover': {
    color: 'white',
  },
}));
